import UseMediaQuery from './useMediaQuery';

export default UseMediaQuery;
